import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderDetailManagementTable } from '@components/templates/myAccount/manageOrderDetail/OrderDetailManagementTable';

export interface OrderDeliveryTableProps {
    deliveries: {
        id: string;
        name?: string;
        address: string | JSX.Element;
    }[];
    showEditModal?: (id: string) => void;
}

export const OrderDeliveryTable: FC<OrderDeliveryTableProps> = ({ deliveries, showEditModal }) => {
    const { t } = useTranslation();

    const translations = {
        address: t('delivery-table-component.header.address'),
    };

    return (
        <OrderDetailManagementTable
            withActions={showEditModal ? true : false}
            header={[{ text: translations.address }]}
            content={deliveries.map((delivery) => {
                return {
                    cells: [
                        {
                            content: (
                                <>
                                    <b>{delivery.name}</b>
                                    <br />
                                    <p style={{ whiteSpace: 'pre-line' }}>{delivery.address}</p>
                                </>
                            ),
                        },
                    ],
                    options: showEditModal
                        ? [
                              {
                                  icon: 'fa-light fa-pen-to-square',
                                  action: () => showEditModal(delivery.id),
                              },
                          ]
                        : [],
                };
            })}
        />
    );
};
